const firebaseConfig = {
  apiKey: 'AIzaSyAw_xhBg9UbuFkkFKBlN68qWtlq8rHrEOs',
  authDomain: 'filmoteka-dd786.firebaseapp.com',
  databaseURL: 'https://filmoteka-dd786-default-rtdb.firebaseio.com',
  projectId: 'filmoteka-dd786',
  storageBucket: 'filmoteka-dd786.appspot.com',
  messagingSenderId: '180640582478',
  appId: '1:180640582478:web:accff74b384596a105ec1f',
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
